import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import { CSSTransitionGroup } from 'react-transition-group';

import ResponsiveImage from '../helpers/responsiveImage/ResponsiveImage';
import { getActiveSlideId } from '../helpers/galleryUtils/utils';
import { isFullScreenAvailable } from '../helpers';

import * as GalleryActions from './GalleryActions';
import * as AppActions from '../app/AppActions';
import './Style';

import fullscreenImg from '../assets/img/fullscreen.svg';
import exitFullscreenImg from '../assets/img/exitFullscreen.svg';

export class GalleryFullscreenContainer extends Component {
    constructor(props) {
        super(props);

        this.sliderAfterChange = this.sliderAfterChange.bind(this);

        this.state = {
            settings: {
                dots: false,
                infinite: true,
                speed: 500,
                slidesToShow:1,
                slidesToScroll: 1,
                arrows: true,
                lazyLoad: true,
                draggable: false,
                afterChange: this.sliderAfterChange,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            draggable: true
                        }
                    }
                ]
            }
        }

        this.keyDown = this.keyDown.bind(this);
        this.escHandler = this.escHandler.bind(this);
        this.closeBtnClick = this.closeBtnClick.bind(this);
        this.fullscreenBtnClick = this.fullscreenBtnClick.bind(this);
    }

    componentDidMount() {
        window.addEventListener('keydown', this.keyDown, false);
        window.addEventListener('fullscreenchange', this.escHandler, false);
        window.addEventListener('webkitfullscreenchange', this.escHandler, false);
        window.addEventListener('mozfullscreenchange', this.escHandler, false);
        window.addEventListener('MSFullscreenChange', this.escHandler, false);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.keyDown, false);
        window.removeEventListener('fullscreenchange', this.escHandler, false);
        window.removeEventListener('webkitfullscreenchange', this.escHandler, false);
        window.removeEventListener('mozfullscreenchange', this.escHandler, false);
        window.removeEventListener('MSFullscreenChange', this.escHandler, false);
    }

    keyDown(e) {
        if (e.keyCode === 27) {
            this.props.appActions.redirectToHome();
        }

        if (e.keyCode === 76 || e.keyCode === 37) {
            this.slider.slickPrev();
        }

        if (e.keyCode === 82 || e.keyCode === 39) {
            this.slider.slickNext();
        }
    }

    closeBtnClick() {
        this.props.appActions.redirectToHome();
    }

    escHandler() {
        if (this.props.isFullscreen
            && !document.fullscreenElement
            && !document.webkitIsFullScreen
            && !document.mozFullScreen
            && !document.msFullscreenElement) {
                this.props.appActions.toggleFullscreen('gallery-fullscreen');
        }
    }

    fullscreenBtnClick() {
        this.props.appActions.toggleFullscreen('gallery-fullscreen');
    }

    sliderAfterChange(e) {
        this.props.galleryActions.setActiveImage(this.props.images[e].file_name);
    }

    render() {
        const {
            imagesPath,
            imageSizeParams,
            images,
            activeSlideName,
            isFullscreen
        } = this.props;

        if (!activeSlideName) {
            return <div className="loader"></div>;
        }

        const { settings } = this.state;

        const activeImage = images.find(img => {
            return img.file_name === activeSlideName
        });

        const captionBlock = activeImage.title || activeImage.description.text
            ? (
                <div className="caption-overlay">
                    <div className="caption">
                        <div className="title">{activeImage.title}</div>
                        <div className="subtitle">{activeImage.description.text}</div>
                    </div>
                </div>
            )
            : null;

        const fullscreenBtn = isFullScreenAvailable()
            ? (
                <button className="fullscreen btn" onClick={this.fullscreenBtnClick}>
                    <img src={isFullscreen ? exitFullscreenImg : fullscreenImg} alt=""/>
                </button>
            )
            : null;

        return (
            <div>
                <CSSTransitionGroup
                    transitionName="opacityAnim"
                    transitionAppear={true}
                    transitionAppearTimeout={500}
                    transitionEnter={false}
                    transitionLeave={false}>
                    <div id="gallery-fullscreen" className="gallery-fullscreen" key={'gallery'}>
                        <div className="header-overlay">
                            <div className="slides-count">
                                {getActiveSlideId(images, activeSlideName) + 1} of {images.length}
                            </div>
                            <button className="slider-close btn" onClick={this.closeBtnClick}>
                                <i className="fa fa-times-circle" aria-hidden="true"></i>
                            </button>
                            {fullscreenBtn}
                        </div>
                        <div className="gallery-fullscreen-wrapper">
                            <Slider
                                ref={slider => this.slider = slider}
                                className="gallery-fullscreen-slider"
                                initialSlide={getActiveSlideId(images, activeSlideName)}
                                {...settings}>
                                {Object.values(images).map((image, i) => {
                                    return (
                                        <div className="slider-img-container" key={i}>
                                            {captionBlock}
                                            <ResponsiveImage
                                                imagesPath={imagesPath}
                                                imageSizeParams={imageSizeParams}
                                                filename={image.file_name}
                                                lazyLoad={this.props.lazyLoad}
                                            />
                                        </div>
                                    )
                                })}
                            </Slider>
                        </div>
                    </div>
                </CSSTransitionGroup>
            </div>
        )
    }
}

GalleryFullscreenContainer.propTypes = {
    imagesPath: PropTypes.string.isRequired,
    images: PropTypes.array.isRequired,
    imageSizeParams: PropTypes.object.isRequired,
    activeSlideName: PropTypes.string.isRequired
};

const mapStateToProps = (state) => ({
    imagesPath: state.gallery.imagesPath,
    images: state.gallery.images,
    imageSizeParams: state.gallery.imageSizeParams,
    activeSlideName: state.gallery.activeSlideName,
    isFullscreen: state.app.isFullscreen
});

const mapDispatchToProps = (dispatch) => ({
    appActions: bindActionCreators(AppActions, dispatch),
    galleryActions: bindActionCreators(GalleryActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(GalleryFullscreenContainer)
